import { SET_SHOW_OFF_CANVAS } from './../const'

export default (showOffCanvas) => {
    return {
      type: SET_SHOW_OFF_CANVAS,
      showOffCanvas: showOffCanvas
    }
};